import {
  signupState,
  SubscriptionType,
} from '@farmersdog/lead-browser-storage';

import { DiscountBannerInner } from './DiscountBannerInner';
import { FreshDiscountBanner } from './FreshDiscountBanner';

export function DiscountBanner() {
  const { subscriptionTypes } = signupState.get();
  const productLine = subscriptionTypes.current;

  switch (productLine) {
    case SubscriptionType.Diy: {
      return (
        <DiscountBannerInner copy="Free shipping on DIY orders. Because dogs." />
      );
    }

    case SubscriptionType.Fresh: {
      return <FreshDiscountBanner />;
    }
  }
}
